var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Container, Grid, ListItemIcon, Menu, MenuItem, TableCell, TableRow, Typography, Badge } from '@mui/material';
import { FormControlLabel, Checkbox } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ArrowDropDown, AttachMoney, Edit, Visibility, NoteAdd, NotificationsNoneOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { TipoDocumentoEnum } from '../../../model/enums/TipoDocumentoEnum';
import { TipoAtendimentoEnum } from '../../../model/enums/TipoAtendimentoEnum';
import { Requerimento } from '../../../model/Requerimento';
import { TipoRequerenteEnum } from '../../../model/enums/TipoRequerenteEnum';
import { HandleError } from '../../utils/HandleError';
import { SituacaoRequerimentoEnum } from '../../../model/enums/SituacaoRequerimentoEnum';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { ServicoApi } from '../../../apis/servico-api';
import { ShowContent } from '../../../components/ShowContent';
import CustomAxios from '../../../util/customAxios';
import { DefaultButtonsListView } from '../../../components/Defaults/SearchView/DefaultButtonsListView';
import { DefaultAccordionFilter } from '../../../components/Defaults/SearchView/DefaultAccordionFilter';
import { DefaultTable } from '../../../components/Defaults/table/DefaultTable';
import { DefaultTemplateListView } from '../../../components/Defaults/SearchView/DefaultTemplateListView';
import { BoxContainerLayout } from '../../../components/BoxContainerLayout';
import { Page } from '../../../apis/list-process-api';
import { DefaultFilterOrder } from '../../../components/DefaultFilterOrder';
import { AuthConstants } from '../../../util/auth-constants';
import { Format } from '../../../util/Format';
import { DateUtils } from '../../../util/DateUtils';
import { Routes } from '../../../routes/constants';
import { LocalStorageUtils } from '../../../util/LocalStorageUtils';
import { useUserInfoStore } from '../../../util/UserInfoStore';
import { DefaultAutoComplete } from '../../../components/DefaultAutoComplete';
import { CustomInputForm } from '../../../components/Forms/CustomInputForm';
import { TipoProcessoEnum } from '../../../model/enums/TipoProcessoEnum';
import { Notification } from '../../../components/Notification';
import { ButtonBox } from '../../../components/common';
import { NotificacaoApi } from '../../../apis/notificacao-api';
var RequerimentoPesquisaFilter = /** @class */ (function () {
    function RequerimentoPesquisaFilter() {
    }
    return RequerimentoPesquisaFilter;
}());
export var RequerimentoPesquisa = function () {
    //region Constants
    var rowsPerPage = 5;
    var _a = useState({ severity: 'info', open: false, message: '' }), notification = _a[0], setNotification = _a[1];
    var navigate = useNavigate();
    var _b = useState(new Page()), requerimentos = _b[0], setRequerimentos = _b[1];
    var _c = useState(), servicoSelecionado = _c[0], setServicoSelecionado = _c[1];
    var loggedUser = useUserInfoStore(function (state) { return state.userInfo; });
    var _d = useState([]), servicoDisponivel = _d[0], setServicoDisponivel = _d[1];
    var _e = useState(null), anchorEl = _e[0], setAnchorEl = _e[1];
    var _f = useState(false), loading = _f[0], setLoading = _f[1];
    var _g = React.useState('1'), value = _g[0], setValue = _g[1];
    var _h = useState(0), page = _h[0], setPage = _h[1];
    var _j = useState(), error = _j[0], setError = _j[1];
    var params = new URLSearchParams(window.location.search);
    var _k = useState({
        nomeRepresentante: '',
        protocolo: '',
        documento: '',
        situacao: '',
        ordem: '',
        campo: '',
        nome: '',
        servico: undefined,
    }), filter = _k[0], setFilter = _k[1];
    var _l = useState(false), somenteConcluidos = _l[0], setSomenteConcluidos = _l[1];
    var _m = useState(0), pendingCount = _m[0], setPendingCount = _m[1];
    var fieldOptions = [
        { label: 'Nome', value: 'nome' },
        { label: 'Id', value: 'id' },
        { label: 'CPF', value: 'cpf' },
        { label: 'Situação', value: 'situacao' },
    ];
    //endregion
    //region Hooks
    var tipoServParam = useMemo(function () {
        return params.get('tipoServico');
    }, []);
    function formatSigadocDisplay(sigadoc) {
        if (!sigadoc)
            return '';
        if (sigadoc.toUpperCase().startsWith('TMP-')) {
            return sigadoc;
        }
        var limpo = sigadoc.replace(/[^A-Z0-9]/gi, '').toUpperCase();
        if (limpo.startsWith('INTERMATPRO')) {
            var restante = limpo.substring('INTERMATPRO'.length);
            if (restante.length >= 4) {
                var ano = restante.substring(0, 4);
                var numero = restante.substring(4);
                numero = numero.padStart(5, '0');
                return "INTERMAT-PRO-".concat(ano, "/").concat(numero);
            }
        }
        if (limpo.startsWith('INTERMATCAP')) {
            var restante = limpo.substring('INTERMATCAP'.length);
            if (restante.length >= 4) {
                var ano = restante.substring(0, 4);
                var numero = restante.substring(4);
                numero = numero.padStart(5, '0');
                return "INTERMAT-CAP-".concat(ano, "/").concat(numero);
            }
        }
        if (!isNaN(Number(limpo))) {
            var numeroFormatado = limpo.padStart(5, '0');
            var ano = new Date().getFullYear();
            return "INTERMAT-PRO-".concat(ano, "/").concat(numeroFormatado);
        }
        return sigadoc;
    }
    useEffect(function () {
        if (!tipoServParam) {
            handleConsultarRequerimentos();
        }
        handleLoadServico();
        NotificacaoApi.pageable({ page: 0, size: 100, status: '', idRequerimento: '' })
            .then(function (res) {
            if (res && res.content) {
                var count = res.content.filter(function (n) { var _a; return ((_a = n.status) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'pendente'; }).length;
                setPendingCount(count);
            }
        })
            .catch(function (err) { return console.warn("Erro ao buscar notificações para a badge:", err); });
    }, []);
    useEffect(function () {
    }, [requerimentos]);
    useEffect(function () {
    }, [filter]);
    useEffect(function () {
        if (!tipoServParam && loggedUser) {
            handleConsultarRequerimentos();
        }
    }, [loggedUser]);
    useEffect(function () {
        if (tipoServParam && (servicoDisponivel === null || servicoDisponivel === void 0 ? void 0 : servicoDisponivel.length) > 0) {
            handleLoadServicos(tipoServParam);
        }
    }, [tipoServParam, servicoDisponivel === null || servicoDisponivel === void 0 ? void 0 : servicoDisponivel.length]);
    useEffect(function () {
        if (servicoSelecionado) {
            handleSearch();
        }
    }, [servicoSelecionado]);
    //endregion
    //region Handles
    var handleValidToNew = function (_requerimentos) {
        if (!!servicoSelecionado && (_requerimentos === null || _requerimentos === void 0 ? void 0 : _requerimentos.totalElements) === 0) {
            handleNew(null, servicoSelecionado);
        }
    };
    var handleLoadServicos = function (tipoServico) {
        var tipoServicoEnum = TipoProcessoEnum.of(tipoServico);
        if (tipoServicoEnum) {
            var servico = servicoDisponivel.find(function (it) { return it.referenciaServico === tipoServicoEnum; });
            setFilter(__assign(__assign({}, filter), { servico: servicoSelecionado }));
            setServicoSelecionado(servico);
            if (!servico) {
                setNotification({
                    message: 'Serviço não encontrado.',
                    severity: 'warning',
                    open: true,
                    duration: 6000,
                    vertical: 'top'
                });
                setFilter(__assign(__assign({}, filter), { servico: undefined }));
                handleConsultarRequerimentos();
            }
        }
    };
    var handleLoadServico = function () {
        ServicoApi.selectByMode(TipoAtendimentoEnum.ONLINE)
            .then(function (results) { return setServicoDisponivel(__spreadArray([], results, true)); })
            .catch(function (error) { return setError(error); });
    };
    var handleConsultarRequerimentos = function (params) { return __awaiter(void 0, void 0, Promise, function () {
        var data, totalElements, pageIndex, totalPages, response, newPage, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!!loading) return [3 /*break*/, 5];
                    setLoading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    data = [];
                    totalElements = 0;
                    pageIndex = (params === null || params === void 0 ? void 0 : params.page) || 0;
                    totalPages = 0;
                    return [4 /*yield*/, CustomAxios.get("/api/requerimento/meus")];
                case 2:
                    response = _c.sent();
                    data = Array.isArray(response.data) ? response.data : (((_a = response.data) === null || _a === void 0 ? void 0 : _a.content) || []);
                    // Filtros Client-Side
                    if ((filter === null || filter === void 0 ? void 0 : filter.situacao) && filter.situacao !== 'CONCLUIDO') {
                        data = data.filter(function (item) { return item.status === filter.situacao || item.situacao === filter.situacao; });
                    }
                    if (somenteConcluidos || (filter === null || filter === void 0 ? void 0 : filter.situacao) === 'CONCLUIDO') {
                        data = data.filter(function (item) {
                            return item.status === 'CONCLUIDO' ||
                                item.status === 'PREENCHIMENTO_FINALIZADO' ||
                                item.status === 'ISENTO_TAXAS' ||
                                item.situacao === 'CONCLUIDO' ||
                                item.situacao === 'PREENCHIMENTO_FINALIZADO' ||
                                item.situacao === 'ISENTO_TAXAS';
                        });
                    }
                    if (servicoSelecionado === null || servicoSelecionado === void 0 ? void 0 : servicoSelecionado.id) {
                        data = data.filter(function (item) { var _a; return ((_a = item.servico) === null || _a === void 0 ? void 0 : _a.id) === servicoSelecionado.id || item.codigoServico === servicoSelecionado.id; });
                    }
                    if ((_b = filter === null || filter === void 0 ? void 0 : filter.servico) === null || _b === void 0 ? void 0 : _b.id) {
                        data = data.filter(function (item) { var _a, _b, _c; return ((_a = item.servico) === null || _a === void 0 ? void 0 : _a.id) === ((_b = filter.servico) === null || _b === void 0 ? void 0 : _b.id) || item.codigoServico === ((_c = filter.servico) === null || _c === void 0 ? void 0 : _c.id); });
                    }
                    totalElements = data.length;
                    totalPages = Math.ceil(totalElements / rowsPerPage);
                    // Paginação Client-Side (simulada para Tabela)
                    data = data.slice(pageIndex * rowsPerPage, (pageIndex + 1) * rowsPerPage);
                    newPage = {
                        content: data,
                        totalElements: totalElements,
                        totalPages: totalPages,
                        pageNumber: pageIndex,
                        size: rowsPerPage,
                        empty: data.length === 0,
                        first: pageIndex === 0,
                        last: pageIndex >= totalPages - 1
                    };
                    setRequerimentos(newPage);
                    setPage(pageIndex + 1);
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _c.sent();
                    setError(err_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleUnformatCpfCnpj = function (doc) {
        return doc === null || doc === void 0 ? void 0 : doc.replaceAll('.', '').replaceAll('-', '').replaceAll('/', '');
    };
    var handleChangePage = function (newPage) { return __awaiter(void 0, void 0, Promise, function () {
        var params;
        return __generator(this, function (_a) {
            setPage(newPage);
            setLoading(true);
            params = mountParams(newPage - 1);
            handleConsultarRequerimentos(params);
            return [2 /*return*/];
        });
    }); };
    var handleChange = function (newValue) {
        setValue(newValue);
    };
    var handleSearch = function () { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            setValue('1');
            handleConsultarRequerimentos({ page: 0 });
            return [2 /*return*/];
        });
    }); };
    var mountParams = function (newPage) {
        var _a, _b, _c, _d;
        var params = {};
        params.page = newPage !== null && newPage !== void 0 ? newPage : page - 1;
        params.size = rowsPerPage;
        params.sort = handleSort();
        if (filter === null || filter === void 0 ? void 0 : filter.nome) {
            params.nome = filter === null || filter === void 0 ? void 0 : filter.nome;
        }
        if (filter === null || filter === void 0 ? void 0 : filter.documento) {
            params.documento = handleUnformatCpfCnpj(filter === null || filter === void 0 ? void 0 : filter.documento);
        }
        if (filter === null || filter === void 0 ? void 0 : filter.nomeRepresentante) {
            params.nomeRepresentante = filter === null || filter === void 0 ? void 0 : filter.nomeRepresentante;
        }
        if (filter === null || filter === void 0 ? void 0 : filter.nome) {
            params.requerente = filter === null || filter === void 0 ? void 0 : filter.nome;
        }
        // Se o checkbox 'Somente Concluídos' estiver selecionado, força a situação para CONCLUIDO
        if (somenteConcluidos) {
            params.situacao = 'CONCLUIDO';
        }
        else if (filter === null || filter === void 0 ? void 0 : filter.situacao) {
            // Se selecionou CONCLUIDO no dropdown, manda como CONCLUIDO (será filtrado em handleConsultarRequerimentos)
            params.situacao = filter === null || filter === void 0 ? void 0 : filter.situacao;
        }
        if (servicoSelecionado === null || servicoSelecionado === void 0 ? void 0 : servicoSelecionado.id) {
            params.servico = servicoSelecionado === null || servicoSelecionado === void 0 ? void 0 : servicoSelecionado.id;
        }
        if ((_a = filter === null || filter === void 0 ? void 0 : filter.servico) === null || _a === void 0 ? void 0 : _a.id) {
            params.servico = (_b = filter === null || filter === void 0 ? void 0 : filter.servico) === null || _b === void 0 ? void 0 : _b.id;
        }
        params.documento = (_d = (_c = loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.cpf) !== null && _c !== void 0 ? _c : loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.cnpj) !== null && _d !== void 0 ? _d : '';
        return params;
    };
    var handleSort = function () {
        return filter.ordem && filter.campo
            ? filter.campo + ',' + filter.ordem
            : 'id,desc';
    };
    var handleClear = function () {
        setFilter({
            nomeRepresentante: '',
            protocolo: '',
            documento: '',
            situacao: '',
            ordem: '',
            campo: '',
            nome: '',
            servico: undefined
        });
    };
    var handleMenuSolicitar = function (event) {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
    var handleMenuCloseSolicitar = function () {
        setAnchorEl(null);
    };
    var handleFilterChange = function (event) {
        var _a;
        var _b = event.target, name = _b.name, value = _b.value;
        setFilter(__assign(__assign({}, filter), (_a = {}, _a[name] = value, _a)));
    };
    var handleNew = function (event, servico) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        LocalStorageUtils.removeEncryptedDataFromLocalStorage(AuthConstants.REQUERIMENTO_CACHE);
        handlePreparedNew(servico);
    };
    var handlePreparedNew = function (servico) {
        var temPf = servico.tipoRequerentePf === TipoRequerenteEnum.PESSOA_FISICA;
        var temPj = servico.tipoRequerentePj === TipoRequerenteEnum.PESSOA_JURIDICA;
        var _tipoDoc = temPj ? TipoDocumentoEnum.PJ : null;
        var tipoDoc = temPf ? TipoDocumentoEnum.PF : _tipoDoc;
        if (tipoDoc) {
            var _servico = __assign(__assign({}, servico), { tipoRequerente: [
                    servico.tipoRequerentePf,
                    servico.tipoRequerentePj,
                    servico.tipoRequerenteGov,
                ], tipoAtendimento: [
                    servico.tipoAtendimentoOnline,
                    servico.tipoAtendimentoPresencial,
                ] });
            var _newReq = __assign(__assign({}, new Requerimento()), { tipoRequerimentoDoc: tipoDoc, servico: __assign({}, _servico) });
            LocalStorageUtils.setEncryptedDataInLocalStorage(AuthConstants.REQUERIMENTO_CACHE, __assign({}, _newReq));
            navigate("".concat(Routes.REQUERIMENTO_CADASTRO.path));
        }
        else {
            setError({
                response: {
                    data: {
                        message: 'Este Serviço não suporta requerentes Pessoa Fisica ou Pessoa Jurídica.',
                    },
                },
            });
        }
    };
    var handleCloseError = function () {
        setError(undefined);
    };
    var handlecustomOption = function (row) {
        var _a, _b, _c;
        var podeVisualizar = row.situacao === SituacaoRequerimentoEnum.PREENCHIMENTO_FINALIZADO
            || row.situacao === SituacaoRequerimentoEnum.ISENTO_TAXAS
            || row.situacao === SituacaoRequerimentoEnum.CONCLUIDO;
        return (_jsxs(CustomInputForm, __assign({ helperText: "Click para selecionar", name: "acoes-".concat(row === null || row === void 0 ? void 0 : row.id), id: "acoes-".concat(row === null || row === void 0 ? void 0 : row.id), defaultValue: "", label: "A\u00E7\u00F5es", fullWidth: true, select: true }, { children: [_jsxs(MenuItem, __assign({ disabled: !podeVisualizar, onClick: function () { return podeVisualizar && navigate("".concat(Routes.REQUERIMENTO_VISUALIZAR.path, "/").concat(row.id)); }, value: "visualizar", id: 'visualizar' + ((_a = row === null || row === void 0 ? void 0 : row.id) === null || _a === void 0 ? void 0 : _a.toString()) }, { children: [_jsx(ListItemIcon, { children: _jsx(Visibility, { color: "info", fontSize: "small" }) }), _jsx(Typography, __assign({ variant: "inherit" }, { children: "Visualizar" }))] })), _jsxs(MenuItem, __assign({ onClick: function () { return navigate("".concat(Routes.REQUERIMENTO_EDITAR.path, "/") + row.id); }, id: 'editar' + ((_b = row === null || row === void 0 ? void 0 : row.id) === null || _b === void 0 ? void 0 : _b.toString()), disabled: !!(row === null || row === void 0 ? void 0 : row.documentoSigadoc), value: "editar" }, { children: [_jsx(ListItemIcon, { children: _jsx(Edit, { color: "info", fontSize: "small" }) }), _jsx(Typography, __assign({ variant: "inherit" }, { children: row.situacao === SituacaoRequerimentoEnum.PREENCHIMENTO_EM_ABERTO
                                ? 'Continuar Rascunho'
                                : 'Editar' }))] })), row.possuiTaxa === true &&
                    _jsx(MenuItem, __assign({ onClick: function () {
                            return navigate("".concat(Routes.REQUERIMENTO_EMITIR_TAXAS.path, "/") + row.id);
                        }, id: 'editar' + ((_c = row === null || row === void 0 ? void 0 : row.id) === null || _c === void 0 ? void 0 : _c.toString()), value: "editar" }, { children: _jsxs(_Fragment, { children: [_jsx(ListItemIcon, { children: _jsx(AttachMoney, { color: "info", fontSize: "small" }) }), _jsx(Typography, __assign({ variant: "inherit" }, { children: "Emitir Taxas" }))] }) }))] })));
    };
    var rowStatus = useCallback(function (row) {
        return (_jsx(TableRow, __assign({ tabIndex: -1 }, { children: _jsx(TableCell, __assign({ colSpan: 2, sx: { padding: 0.5, background: '#EAEFF9' } }, { children: _jsxs(Box, __assign({ sx: {
                        display: 'flex',
                        justifyContent: 'left',
                        gap: 1,
                        marginTop: 0,
                        paddingLeft: 0.8,
                    } }, { children: [_jsx(InfoOutlined, { color: "info" }), _jsxs(Typography, __assign({ align: "left", variant: "caption", sx: { marginTop: 0.2, paddingLeft: 0 } }, { children: ["Situa\u00E7\u00E3o: ", SituacaoRequerimentoEnum.getDescricao(row === null || row === void 0 ? void 0 : row.situacao)] }))] })) })) })));
    }, []);
    var firstTab = useCallback(function () {
        return (_jsxs(_Fragment, { children: [_jsxs(ButtonBox, __assign({ style: { justifyContent: 'right' } }, { children: [_jsx(ShowContent, __assign({ show: !!(servicoSelecionado === null || servicoSelecionado === void 0 ? void 0 : servicoSelecionado.id) }, { children: _jsxs(Button, __assign({ onClick: function (event) { return handleNew(event, servicoSelecionado); }, endIcon: _jsx(NoteAdd, {}), variant: "contained" }, { children: ["Requerer ", TipoProcessoEnum.getDescricao(servicoSelecionado === null || servicoSelecionado === void 0 ? void 0 : servicoSelecionado.referenciaServico)] })) })), _jsx(Button, __assign({ onClick: handleMenuSolicitar, endIcon: _jsx(ArrowDropDown, {}), variant: "contained" }, { children: "Requerer Novo Servi\u00E7o" })), _jsxs(Menu, __assign({ onClose: handleMenuCloseSolicitar, open: Boolean(anchorEl), anchorEl: anchorEl }, { children: [servicoDisponivel.length > 0 &&
                                    (servicoDisponivel === null || servicoDisponivel === void 0 ? void 0 : servicoDisponivel.map(function (it, index) { return (_jsx(MenuItem, __assign({ onClick: function (e) { return handleNew(e, it); } }, { children: it.nomeReqServico }), "opt_cad_".concat(index.toString()))); })), servicoDisponivel.length === 0 && (_jsx(MenuItem, { children: "Nenhum Servi\u00E7o Dispon\u00EDvel no momento" }, 'no_options_disp'))] }))] })), _jsx(DefaultTable, __assign({ onChange: function (value) { return setRequerimentos(__assign({}, value)); }, handlePageChange: handleChangePage, customOptions: handlecustomOption, customRowStatus: rowStatus, page: requerimentos, currentPage: page, loading: loading }, { children: function (row) {
                        var _a;
                        return (_jsxs(_Fragment, { children: [_jsxs(Typography, __assign({ color: "gray", align: "left", variant: "body2", sx: { paddingLeft: 2.5 } }, { children: ["ID: ", row === null || row === void 0 ? void 0 : row.id] })), _jsxs(ShowContent, __assign({ show: !!(row === null || row === void 0 ? void 0 : row.nomeInventariante) }, { children: [_jsxs(Typography, __assign({ color: "gray", align: "left", variant: "body2", sx: { paddingLeft: 2.5 } }, { children: ["Nome do Requerente: ", row === null || row === void 0 ? void 0 : row.nomeInventariante] })), _jsxs(Typography, __assign({ color: "gray", align: "left", variant: "body2", sx: { paddingLeft: 2.5, paddingBottom: 1.3 } }, { children: ["CPF: ", (row === null || row === void 0 ? void 0 : row.documentoInventariante) ? Format.cpf(row.documentoInventariante) : ''] }))] })), _jsxs(ShowContent, __assign({ show: !(row === null || row === void 0 ? void 0 : row.nomeInventariante) && !!(row === null || row === void 0 ? void 0 : row.nomeRequerente) }, { children: [_jsxs(Typography, __assign({ color: "gray", align: "left", variant: "body2", sx: { paddingLeft: 2.5 } }, { children: ["Nome do Requerente: ", row === null || row === void 0 ? void 0 : row.nomeRequerente] })), _jsx(Typography, __assign({ color: "gray", align: "left", variant: "body2", sx: { paddingLeft: 2.5, paddingBottom: 1.3 } }, { children: (row === null || row === void 0 ? void 0 : row.tipoRequerimentoDoc) === TipoDocumentoEnum.PF ? (_jsxs(_Fragment, { children: ["CPF: ", (row === null || row === void 0 ? void 0 : row.documentoRequerente) ? Format.cpf(row.documentoRequerente) : ''] })) : (_jsxs(_Fragment, { children: ["CNPJ: ", (row === null || row === void 0 ? void 0 : row.documentoRequerente) ? Format.cnpj(row.documentoRequerente) : ''] })) }))] })), _jsxs(ShowContent, __assign({ show: !(row === null || row === void 0 ? void 0 : row.nomeInventariante) && !(row === null || row === void 0 ? void 0 : row.nomeRequerente) && !!(row === null || row === void 0 ? void 0 : row.tipoVinculo) }, { children: [_jsxs(Typography, __assign({ color: "gray", align: "left", variant: "body2", sx: { paddingLeft: 2.5 } }, { children: ["V\u00EDnculo: ", (_a = row === null || row === void 0 ? void 0 : row.tipoVinculo) === null || _a === void 0 ? void 0 : _a.replace(/_/g, ' ')] })), _jsxs(Typography, __assign({ color: "gray", align: "left", variant: "body2", sx: { paddingLeft: 2.5, paddingBottom: 1.3 } }, { children: ["CPF Vinculado: ", (row === null || row === void 0 ? void 0 : row.cpf) ? Format.cpf(row.cpf) : ''] }))] })), _jsxs(Typography, __assign({ color: "gray", align: "left", variant: "body2", sx: { paddingLeft: 2.5, paddingBottom: 1.3 } }, { children: ["Tipo Requerimento:", ' ', row === null || row === void 0 ? void 0 : row.nomeServico] })), _jsxs(Typography, __assign({ color: "gray", align: "left", variant: "body2", sx: { paddingLeft: 2.5 } }, { children: ["Data Cadastro:", ' ', typeof (row === null || row === void 0 ? void 0 : row.dataRequerimento) === 'string' && (row === null || row === void 0 ? void 0 : row.dataRequerimento.includes('/'))
                                            ? row === null || row === void 0 ? void 0 : row.dataRequerimento
                                            : DateUtils.formatDateStrToBRWithTime(row === null || row === void 0 ? void 0 : row.dataRequerimento)] })), _jsxs(Typography, __assign({ color: "gray", align: "left", variant: "body2", sx: { paddingLeft: 2.5 } }, { children: ["SIGADOC: ", (row === null || row === void 0 ? void 0 : row.documentoSigadoc) ? formatSigadocDisplay(row.documentoSigadoc) : 'Documentação do Sigadoc não disponível'] }))] }));
                    } }), 'default-table-requerimento')] }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [anchorEl, servicoDisponivel, requerimentos, page, loading, rowStatus, servicoSelecionado]);
    var secondTab = useCallback(function () {
        return (_jsxs(_Fragment, { children: [_jsxs(DefaultAccordionFilter, __assign({ subTitle: 'Você pode buscar através dos critérios abaixo.', title: 'Filtrar' }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, xl: 6, lg: 6, md: 6 }, { children: _jsx(DefaultAutoComplete, { onChange: function (_servico) { return setFilter(__assign(__assign({}, filter), { servico: __assign({}, _servico) })); }, placeholder: 'Informe o Processo/Requerimento que deseja buscar', label: 'Vinculado ao Processo/Requerimento', noOptionsText: "Nenhum servi\u00E7o encontrado", cbckSearch: ServicoApi.selectAllActives, fieldName: 'nomeReqServico', value: filter === null || filter === void 0 ? void 0 : filter.servico, required: false }) })), _jsxs(Grid, __assign({ item: true, xs: 12, xl: 6, lg: 6, md: 6 }, { children: [_jsxs(CustomInputForm, __assign({ helperText: "Selecione a situa\u00E7\u00E3o que deseja buscar", onChange: handleFilterChange, label: "Situa\u00E7\u00E3o (Opcional)", value: filter === null || filter === void 0 ? void 0 : filter.situacao, name: "situacao", defaultValue: "", id: "situacao", fullWidth: true, select: true }, { children: [_jsx(MenuItem, __assign({ value: '' }, { children: "Nenhum" })), SituacaoRequerimentoEnum.getOptions().map(function (_a, index) {
                                            var value = _a.value, label = _a.label;
                                            return (_jsx(MenuItem, __assign({ value: value }, { children: label }), "".concat(index.toString())));
                                        })] })), _jsx(Box, __assign({ sx: { mt: 1 } }, { children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: somenteConcluidos, onChange: function (e) { setSomenteConcluidos(e.target.checked); if (e.target.checked) {
                                                setFilter(__assign(__assign({}, filter), { situacao: '' }));
                                            } }, name: "somenteConcluidos", color: "primary" }), label: "Somente Conclu\u00EDdos" }) }))] }))] })), _jsx(DefaultFilterOrder, { filter: filter, handleFilterChange: handleFilterChange, fieldOptions: fieldOptions }), _jsx(DefaultButtonsListView, { handleClear: handleClear, handleFind: handleSearch })] }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter]);
    //endregion
    return (_jsxs(BoxContainerLayout, { children: [_jsx(Notification, { props: notification, handleFormChange: setNotification }), _jsxs(Container, __assign({ maxWidth: "md" }, { children: [_jsx(Typography, __assign({ variant: "h4", component: "h1", gutterBottom: true, align: "center", sx: { fontWeight: 'bold', color: 'primary.main', mt: 2 } }, { children: "Meus Requerimentos" })), _jsx(Typography, __assign({ gutterBottom: true, align: "center", color: "textSecondary" }, { children: "Acompanhe aqui o andamento dos seus processos de regulariza\u00E7\u00E3o fundi\u00E1ria." }))] })), _jsx(DefaultTemplateListView, { tabChange: handleChange, secondTab: secondTab(), firstTab: firstTab(), newValue: value, extraTabElement: _jsxs(Button, __assign({ variant: "text", sx: { color: 'text.primary', textTransform: 'none', fontSize: '1rem', fontWeight: 600 }, startIcon: _jsx(NotificationsNoneOutlined, { sx: { color: 'action.active' } }), onClick: function () { return navigate("".concat(Routes.NOTIFICACOES_LISTAR.path)); } }, { children: ["Notifica\u00E7\u00F5es", pendingCount > 0 && (_jsx(Badge, { badgeContent: pendingCount, color: "error", sx: { ml: 2.5, '& .MuiBadge-badge': { right: -5, top: 0 } } }))] })) }), _jsx(HandleError, { error: error, handleClose: handleCloseError })] }));
};
